import React, { useState } from 'react';
import { createGradientOrSolid } from 'utils';
import { StyledBalancesWrapper, StyledHeader } from './style';
import { EGradientDirection } from 'utils/enums';
import { WhispersBalance } from 'templates/Balances/Whispers';
import { HeaderProps } from '../Header/types';

export const WhispersHeader: React.FC<HeaderProps> = ({
  profilePicUrl,
  profilePicBorder = {
    colorOne: '#FFFBDB',
    colorTwo: '#FFD9AB',
    gradientDirection: EGradientDirection.TopToBottom,
  },
  playerName = '',
  openLogoutModal,
  overrideStore,
  logoPicUrl,
  balances = undefined,
  balanceQuantityFormat,
  preview = false,
  showHeader,
  profileFrameImg = '',
  backgroundColor,
  dailyBonusBadges,
}) => {
  const [picLoaded, setPicLoaded] = useState(false);
  const isProfileInfo = balances?.length !== 0 || !!playerName;
  return (
    <StyledHeader
      visibility={showHeader ? 'unset' : 'hidden'}
      isProfileInfo={isProfileInfo}
      backgroundColor={backgroundColor ?? 'transparent'}
      hasBadge={dailyBonusBadges && dailyBonusBadges.length > 0}
      className={'whispers-header'}
    >
      <div className={'header-content'}>
        <div data-hide="true" className="profileContainer">
          <div
            className="frame"
            style={{
              background: !profileFrameImg
                ? createGradientOrSolid(profilePicBorder)
                : 'none',
              border: 'none',
            }}
          >
            {profileFrameImg && (
              <img
                className="profileContainer__profileFrame"
                src={profileFrameImg}
                alt="profile-frame"
                onClick={openLogoutModal}
              />
            )}
            <img
              alt="profile"
              className="profileContainer__img"
              src={profilePicUrl}
              onClick={openLogoutModal}
              style={{ display: picLoaded ? 'unset' : 'none' }}
              onLoad={() => setPicLoaded(true)}
            />
            <img
              alt="profile"
              className="profileContainer__img"
              onClick={openLogoutModal}
              src="https://media.appcharge.com/defaults/old-profile.png"
              style={{ display: picLoaded ? 'none' : 'unset' }}
            />
          </div>
          {isProfileInfo && (
            <StyledBalancesWrapper>
              {balances?.map((balance, index) => (
                <WhispersBalance
                  key={index}
                  balance={{ image: balance.image, amount: balance.amount }}
                  balanceQuantityFormat={balanceQuantityFormat}
                />
              ))}
            </StyledBalancesWrapper>
          )}
        </div>
        <div
          data-hide="true"
          className={`logo ${!isProfileInfo ? 'defaultInfoLogo' : ''}`}
          style={{
            display: 'none',
          }}
        >
          <img
            alt="logo"
            className="logo__main"
            onClick={(e) => {
              if (
                process.env.NODE_ENV === 'development' &&
                e.detail === 3 &&
                !preview
              ) {
                overrideStore();
              }
            }}
            src={logoPicUrl}
          />
        </div>
      </div>
    </StyledHeader>
  );
};
